/**
 * Thin client for adventure_quest_gm session APIs (Option B).
 */
import { ARCADE, API_PATH_PROXY_ENABLED } from '../../../utils/config';
import { acquireGmLease, endGmSession, noteGmState } from '../gmLease';

/** Lease key for this game's shared GM (game_engines/gm_registry.py). */
export const GM_GAME_ID = 'adventure_quest';

export const AQ_GM_BASE = API_PATH_PROXY_ENABLED
    ? (ARCADE.adventure_quest?.API_BASE || '')
    : '/aq';

async function parseJson(res) {
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
        const err = new Error(data.error || `Adventure Quest GM HTTP ${res.status}`);
        err.status = res.status;
        err.data = data;
        throw err;
    }
    return noteGmState(GM_GAME_ID, data);
}

export async function createAqSession() {
    await acquireGmLease(GM_GAME_ID);
    const res = await fetch(`${AQ_GM_BASE}/session/create`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: '{}',
    });
    return parseJson(res);
}

export async function moveAqSession(sessionId, action) {
    const res = await fetch(`${AQ_GM_BASE}/session/${sessionId}/move`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action }),
    });
    return parseJson(res);
}

export async function deleteAqSession(sessionId) {
    if (!sessionId) return;
    endGmSession(GM_GAME_ID, sessionId);
    try {
        await fetch(`${AQ_GM_BASE}/session/${sessionId}/delete`, { method: 'POST' });
    } catch {
        /* best-effort */
    }
}

export const GOBLIN_COMBAT_POINTS = 40;
export const ORC_COMBAT_POINTS = 80;
export const LEVEL_CLEAR_BONUS_PER_LEVEL = 250;
